import React, {useState} from 'react';
import { useTitle } from "fearless-common-ui";
import {ColumnDef} from "@tanstack/react-table";
import {adminRoutes} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import {concepts, Deletable, Group, User} from "fearless-common";
import OrderableTable from "../../components/layout/OrderableTable";
import {backendEndpoints} from "../../libs/backendEndpoints";
import SearchInput from "../../components/SearchInput";
import Description from "../../components/Description";
import CellRender from "../../components/layout/table/CellRender";

const columns: Array<ColumnDef<Group & Deletable & { users: User[] }>> = [
    { id: 'id', accessorKey: 'id', header: 'ID', enableSorting: true },
    { id: 'name', accessorKey: 'name', header: 'Name', enableSorting: true },
    { id: 'created_at', accessorKey: 'created_at', header: 'Created at', cell: CellRender.Date, enableSorting: true },
    { id: 'deleted_at', accessorKey: 'deleted_at', header: 'Deleted at', cell: CellRender.Date, enableSorting: true },
    { id: 'subscription', accessorKey: 'is_subscribed', header: 'Subscriptions', cell: CellRender.CSV, enableSorting: false },
    { id: 'users', accessorKey: 'users', header: `# of ${concepts.GroupMembers}`, cell: CellRender.Length, enableSorting: false },
]

export default function AdminGroups() {
    const [query, setQuery] = useState('');

    useTitle(`Admin ${concepts.Groups}`);

    return (
        <Pages.Centred padded>
            <div className="d-flex align-items-center">
                <h1 className="flex-grow-1 mb-0">{concepts.Groups}</h1>
                <div className="ms-3">
                    <SearchInput onChange={(e) => setQuery(e.target.value)}/>
                </div>
            </div>
            <Description>
                {concepts.Groups} as created by users (or {concepts.CompanyName} employees, of course).
            </Description>
            <OrderableTable
                filterables={[
                    {
                        field_name: 'deleted_at',
                        label: 'Archived',
                        options: [
                            { value: 'null', label: 'Active' },
                            { value: 'not null', label: 'Archived' },
                        ],
                    },
                ]}
                baseEndpoint={backendEndpoints.getAdminGroups}
                memoisedColumns={columns}
                buildLink={(record) => adminRoutes.group(record.id)}
                pagination
                searchQuery={query}
            />
        </Pages.Centred>
    );
}

